import React, { useState, useRef } from 'react'
// eslint-disable-next-line @typescript-eslint/no-unused-vars
import { Form, Input, Select, Button, message, Row, Col } from 'antd'
import { DEEPLINK_OPTIONS, DEEPLINK_TYPE, DOWNLOAD_LINK } from '@lib/constant'
import ProductSearch from './productSearch'
import ArticleDetail from './articleDetail'
import ProductDetail from './productDetail'
import MerchantForm from './merchantForm'
import BrandInfoPage from './brandInfoPage'
import bxlutils from 'bxl-utils'
import CommomForm from './commom'
const { Option } = Select
const FormItem = Form.Item
const layout = {
  labelCol: { span: 4 },
  wrapperCol: { span: 16 },
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
const DeepLinkForm = props => {
  const inputRef = useRef<any>()
  const [deeplinkType, setdeeplinkType] = useState('')
  const [deeplink, setdeeplink] = useState('')
  const setDeeplinkType = value => {
    setdeeplinkType(value)
    setdeeplink('')
  }
  const setParams = (params, p) => {
    const type = DEEPLINK_OPTIONS.find(item => item.value === deeplinkType)
    if (!type) return
    const path = p || type.path
    const deeplink = bxlutils.uri.buildBieyangDeeplink(path, params)
    if (params && params.fullLink) {
      setdeeplink(params.link)
    } else {
      setdeeplink(deeplink)
    }
  }
  const content = () => {
    switch (deeplinkType) {
      case DEEPLINK_TYPE.WEBVIEW_H5:
        return (
          <CommomForm
            setParams={setParams}
            paramValue={'link'}
            paramName={'url'}
            decode
            key={'0'}
          ></CommomForm>
        )
      case DEEPLINK_TYPE.SEARCH_PRODUCT:
        return <ProductSearch setParams={setParams}></ProductSearch>
      case DEEPLINK_TYPE.ARTICLE_DETAIL:
        return <ArticleDetail setParams={setParams}></ArticleDetail>
      case DEEPLINK_TYPE.ARTICLE_HASHTAG:
        return (
          <CommomForm
            setParams={setParams}
            paramValue={'hashtags'}
            paramName={'Hash tags'}
            key={'1'}
          ></CommomForm>
        )
      case DEEPLINK_TYPE.ARTICLE_SEARCH:
        return (
          <CommomForm
            setParams={setParams}
            paramValue={'q'}
            paramName={'KeyWords'}
            key={'2'}
          ></CommomForm>
        )
      case DEEPLINK_TYPE.PRODUCT_DETAIL:
        return <ProductDetail setParams={setParams}></ProductDetail>
      case DEEPLINK_TYPE.COUPON_LIST:
        return <CommomForm setParams={setParams} key={'3'} />
      case DEEPLINK_TYPE.INVITE_CODE:
        return <CommomForm setParams={setParams} key={'4'} />
      case DEEPLINK_TYPE.MERCHANT_DETAIL:
        return <MerchantForm setParams={setParams}></MerchantForm>
      case DEEPLINK_TYPE.BRANKINFOPAGE:
        return <BrandInfoPage setParams={setParams} />
    }
  }
  const copy = link => {
    const input = document.createElement('input')
    input.value = link
    document.body.appendChild(input)
    input.select()
    document.execCommand('copy')
    document.body.removeChild(input)
    message.success('复制成功！')
  }
  return (
    <div className="deeplinkFormContent">
      <Form {...layout}>
        <FormItem label="跳转">
          <Select onChange={setDeeplinkType}>
            {/* eslint-disable-next-line @typescript-eslint/no-unused-vars */}
            {DEEPLINK_OPTIONS.map((item, index) => {
              return (
                <Option value={item.value} key={item.value}>
                  {item.label}
                </Option>
              )
            })}
          </Select>
        </FormItem>
        {content()}
        <FormItem label="deeplink">
          <Input ref={inputRef} value={deeplink} disabled></Input>
          <Button type="link" onClick={() => copy(deeplink)}>
            复制
          </Button>
        </FormItem>
        <FormItem label="app下载链接">
          <div style={{ display: 'flex' }}>
            <div>{DOWNLOAD_LINK}</div>
            <Button type="link" onClick={() => copy(DOWNLOAD_LINK)}>
              复制
            </Button>
          </div>
        </FormItem>
      </Form>
    </div>
  )
}

export default DeepLinkForm
